import API from "./axios";

export class NotificationService {
    getNotificationCount () : Promise<any> {
        return API.post(`api/index.php`, { action: 'getNewNoficationsCount', src: 'dashboard', retrievalmode: 'mysql' });
    }

}